(function() { window.GUID_a58fd19f_85ec_444d_8a52_00a2073b99ca = { getGuid: function() { return "a58fd19f-85ec-444d-8a52-00a2073b99ca"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        var CamLight;
        (function (CamLight) {
            var ViewModels;
            (function (ViewModels) {
                let RoundEditAction;
                (function (RoundEditAction) {
                    RoundEditAction[RoundEditAction["delete"] = 0] = "delete";
                    RoundEditAction[RoundEditAction["preview"] = 1] = "preview";
                    RoundEditAction[RoundEditAction["next"] = 2] = "next";
                })(RoundEditAction = ViewModels.RoundEditAction || (ViewModels.RoundEditAction = {}));
            })(ViewModels = CamLight.ViewModels || (CamLight.ViewModels = {}));
        })(CamLight = Views.CamLight || (Views.CamLight = {}));
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=RoundEditAction.pre.js.map
